import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../controllers/application'
// rebuild marker: product tags feature 2026-08-30

// (rebuild marker: 2026-07-29 — tenant_type fix, email required, comanda on paid, menu fix)
createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.tsx', { eager: true })
    return pages[`../pages/${name}.tsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})

// build marker 1784992260 — portal cliente: enlace 10 dias + reenvio + datos del invitado (2026-09-18)
